






































































































import Vue, { PropType } from "vue";
import timezones from "@/common/assets/timezones.json";
import { CreateAdminStoreData } from "@/stores/pages/models/CreateAdminStoreData";
import { DEFAULT_STORE_TIME_ZONE } from "@/common/constants/Constants";
import { FieldRules } from "@/common/utils/FieldRules";

export default Vue.extend({
  name: "BasicInformationEdit",
  props: {
    model: {
      type: Object as PropType<CreateAdminStoreData>,
      required: true,
    },
  },
  data() {
    return {
      timeZoneValues: timezones.map((zone) => {
        return { text: zone, value: zone };
      }),
      defaultTimeZone: DEFAULT_STORE_TIME_ZONE,
      ...FieldRules,
    };
  },
  beforeMount(): void {
    this.model.timeZone = this.defaultTimeZone;
  },
});
